import { mergeProps } from 'solid-js';
import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    defaultAriaLabel: 'Menu Bars Icon',
};

export const MenuBarsIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props} fill="currentColor">
            <path d="M17.8618 3.57122C17.8618 3.96571 17.5913 4.28551 17.2576 4.28551L2.75562 4.28551C2.4219 4.2855 2.15137 3.96571 2.15137 3.57122C2.15137 3.17673 2.4219 2.85693 2.75562 2.85693H17.2576C17.5913 2.85693 17.8618 3.17673 17.8618 3.57122Z" />
            <path d="M17.8618 9.99979C17.8618 10.3943 17.5913 10.7141 17.2576 10.7141L2.75562 10.7141C2.4219 10.7141 2.15137 10.3943 2.15137 9.99979C2.15137 9.6053 2.4219 9.28551 2.75562 9.28551L17.2576 9.28551C17.5913 9.28551 17.8618 9.6053 17.8618 9.99979Z" />
            <path d="M17.2576 17.1426C17.5913 17.1426 17.8618 16.8229 17.8618 16.4284C17.8618 16.0339 17.5913 15.7141 17.2576 15.7141L2.75562 15.7141C2.4219 15.7141 2.15137 16.0339 2.15137 16.4284C2.15137 16.8229 2.4219 17.1426 2.75562 17.1426L17.2576 17.1426Z" />
        </SvgIcon>
    );
};
